Namespace 'Monitoring.Reports.Publications'

class Monitoring.Reports.Publications.ReportGranularityView extends Backbone.View
  
  template: JST['backbone/templates/monitoring/reports/publications/granularity']
  events:
    'click .granularity': 'onChangeGranularity'

  initialize: (beginTime, endTime) ->
    dateFrom = new Date(@swapDaysAndMonthsPosition (beginTime))
    dateTo = new Date(@swapDaysAndMonthsPosition (endTime))
    @time = new Monitoring.Reports.Publications.TimeGranularity(dateFrom, dateTo, this)
    # just set @options

  render: ->
    dateFromString = @swapDaysAndMonthsPosition(@time.formatToString(@time.dateFrom))
    dateToString = @swapDaysAndMonthsPosition(@time.formatToString(@time.dateTo))
    @$el.html(@template({begin_time: dateFromString, end_time: dateToString}))
    threeYearsAgo = new Date()
    threeYearsAgo.setFullYear(threeYearsAgo.getFullYear() - 3)
    startDate = if @time.dateFrom > threeYearsAgo then @time.dateFrom else threeYearsAgo
    @$('.date').datepicker(
      autoclose: true
      format: 'dd/mm/yyyy'
      todayBtn: 'linked'
      todayHighlight: true
      startDate: startDate
      endDate: @time.dateTo
    ).on('changeDate', @dateChanged)
    @timezoneSelectorView = new Monitoring.Views.TimeZoneSelectorView()
    @$el.find('#time_zone_selector').html(@timezoneSelectorView.render().el)
    return this

  changeTimeInTemplate:(dateFrom, dateTo) ->
    @$('#date_since_dimension').datepicker("update", dateFrom)
    @$('#date_until_dimension').datepicker("update", dateTo)
    
  onChangeGranularity:(event) ->
    @unCheckAll()
    @check(event.currentTarget)
    dimension = @findDimensionChecked().id
    @disableOrEnableDateSinceDatePicker(dimension)
    @time.changeByDimension(dimension)

  findDimensionChecked:()->
    _.find @$('.granularity') , (input)-> input.checked


  dateChanged:(event)=>
    dateFromSelected = @$('#date_since_dimension').datepicker("getDate")
    dateToSelected = @$('#date_until_dimension').datepicker("getDate")
    @time.changeDates(dateFromSelected, dateToSelected)
    dimension = @currentTargetChecked().id

    @time.changeByDimension(dimension)
    
  unCheckAll: ()->
    _.each(@$('.granularity'), (checkbox)-> checkbox.checked = false);

  check:(checkbox)->
    checkbox.checked = true
 
  isChecked: (checkbox)->
    checkbox.checked

  currentTargetChecked: ()->
    allTargets = @$('.granularity')
    for checkbox in allTargets
      if @isChecked(checkbox)
        return checkbox

  swapDaysAndMonthsPosition:(date)->
    dateSplitted = date.split('/')
    day = dateSplitted[0]
    month = dateSplitted[1]
    year = dateSplitted[2]
    month+'/'+day+'/'+year

  getAnalysisDate:()->
    @time

  getAnalysisTimezone: () ->
    @timezoneSelectorView.getSelectedTimeZone()

  disableOrEnableDateSinceDatePicker: (dimension)->
    return
    if dimension !='history'
      @$("#date_since_dimension").prop('disabled', true)
    else
      @$("#date_since_dimension").prop('disabled', false)
